import router from '@/router';
import { $deleteFromArray, $handleError, $updateOrAdd } from '@/utils';
import userService from '@User/service/userInvitation.service';
import Vue from 'vue';
export const USER_INVITATION = {
  namespaced: true,
  state: {
    entries: [],
    total: 0,
    loading: false,
    inviteLoading: false,
    options: {},
  },
  getters: {
    GET_ENTRIES(state) {
      return state.entries;
    },
    GET_TOTAL(state) {
      return state.total;
    },
    GET_LOADING(state) {
      return state.loading;
    },
    GET_OPTIONS(state) {
      return state.options;
    },
  },
  mutations: {
    SET_ENTRIES(state, value) {
      state.entries = value;
    },
    ADD_TO_ENTRIES(state, value) {
      $updateOrAdd(state.entries, value);
    },
    SET_TOTAL(state, value) {
      state.total = value;
    },
    SET_LOADING(state, value) {
      state.loading = value;
    },
    SET_INVITE_LOADING(state, value) {
      state.inviteLoading = value;
    },
    SET_OPTIONS(state, value) {
      state.options = value;
    },
  },
  actions: {
    GET({ commit, state }) {
      commit('SET_LOADING', true);
      userService
        .get(state.options)
        .then((res) => {
          commit('SET_ENTRIES', res.data.items);
          commit('SET_TOTAL', res.data.total);
        })
        .catch((err) => {
          $handleError(err);
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    },
    GET_BY_ID(_, id) {
      return userService.getById(id);
    },
    GET_BY_COMPANY_ID({ commit, state }, companyId) {
      commit('SET_LOADING', true);
      userService
        .getByCompanyId(companyId, state.options)
        .then((res) => {
          commit('SET_ENTRIES', res.data.items);
          commit('SET_TOTAL', res.data.total);
        })
        .catch((err) => {
          $handleError(err);
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    },
    RESEND(_, id) {
      return userService.resend(id);
    },
    ACCEPT({ commit }, { data, invitationId }) {
      commit('SET_INVITE_LOADING', true);
      return new Promise((resolve, reject) => {
        return userService
          .accept(data, invitationId)
          .then(() => {
            commit('SET_INVITE_LOADING', false);
            router.replace('/login');
            Vue.prototype.$dialog.notify.success(
              'Your Data Has Been Saved Successfully! Please Proceed to Log In Using Your Email and Password.',
              {
                position: 'top-right',
                timeout: 3000,
              },
            );
            resolve();
          })
          .catch((err) => {
            commit('SET_INVITE_LOADING', false);
            $handleError(err);
            reject();
          });
      });
    },
    DELETE({ state, commit }, id) {
      return userService
        .del(id)
        .then(() => {
          $deleteFromArray(state.entries, id);
          commit('SET_TOTAL', --state.total);
          Vue.prototype.$dialog.notify.success('Deleted Successfully', {
            position: 'top-right',
            timeout: 3000,
          });
        })
        .catch((err) => {
          $handleError(err);
        });
    },
  },
};
